export default __webpack_public_path__ + "1c0ecc9e1ae03899cd32831040472bb9.svg";